export default Object.fromEntries(
  [
    'CUSTOMIZE',
    'DELIVERY_NOTE',
    'DELIVERY_PERIOD',
    'DROP_OFF',
    'NEIGHBOUR',
    'PARCEL_SHOP',
    'TRUST_PILOT_CONSENT_DIALOG',
    'DELIVER_TO_PARCELSHOP'
  ].map(dialog => [dialog, dialog])
);
